/**
 * 超简单的teamId加密解密工具 (总共不到30行代码)
 */
export class SimpleEncrypt {
  
  /**
   * 加密teamId
   * @param {string} teamId 原始teamId
   * @returns {string} 加密后的teamId
   */
  static encrypt(teamId) {
    return btoa(teamId.split('').reverse().join(''))
  }
  
  /**
   * 解密teamId
   * @param {string} encrypted 加密的teamId
   * @returns {string|null} 解密后的teamId
   */
  static decrypt(encrypted) {
    try {
      return atob(encrypted).split('').reverse().join('')
    } catch {
      return null
    }
  }
  
  /**
   * 检查是否为加密格式
   * @param {string} text 要检查的文本
   * @returns {boolean} 是否为加密格式
   */
  static isEncrypted(text) {
    return /^[A-Za-z0-9+/=]+$/.test(text) && text.length > 4
  }
}

export default SimpleEncrypt
